import { EntityType } from '@/plugins/cad/module/CADModule/model/common/constant'
import type { IEntity } from '@/plugins/cad/module/CADModule/model/entity/BaseEntity'

export interface CadEntityStats {
  total: number
  textLike: number
  mText: number
  dimension: number
  angularDimension: number
  mLeader: number
  hatch: number
  typeSummary: string
}

function getEntityTypeName(type: unknown): string {
  return String(type)
}

export function collectCadEntityStats(entities: readonly IEntity[]): CadEntityStats {
  const counts = new Map<string, number>()
  let textLike = 0
  let mText = 0
  let dimension = 0
  let angularDimension = 0
  let mLeader = 0
  let hatch = 0

  for (const entity of entities) {
    const typeName = getEntityTypeName(entity.type)
    counts.set(typeName, (counts.get(typeName) ?? 0) + 1)

    if (entity.type === EntityType.MText) {
      mText += 1
      textLike += 1
    } else if (entity.type === EntityType.AlignDimension) {
      dimension += 1
      textLike += 1
    } else if (entity.type === EntityType.AngularDimension) {
      angularDimension += 1
      textLike += 1
    } else if (entity.type === EntityType.MLeader) {
      mLeader += 1
      textLike += 1
    } else if (entity.type === EntityType.Hatch) {
      hatch += 1
    }
  }

  const typeSummary = Array.from(counts.entries())
    .sort((a, b) => b[1] - a[1])
    .map(([type, count]) => `${type}:${count}`)
    .join('|')

  return {
    total: entities.length,
    textLike,
    mText,
    dimension,
    angularDimension,
    mLeader,
    hatch,
    typeSummary,
  }
}

export function formatCadEntityStats(stats: CadEntityStats): string {
  return `total=${stats.total}, textLike=${stats.textLike}, mText=${stats.mText}, dimension=${stats.dimension}, angularDimension=${stats.angularDimension}, mLeader=${stats.mLeader}, hatch=${stats.hatch}, types=${stats.typeSummary}`
}

export function shouldLogCadEntityStats(stats: CadEntityStats): boolean {
  return stats.total >= 50 || stats.textLike > 0 || stats.hatch >= 10
}
